var _rect, _rect2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLavatory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lavatory") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.18,
    y: 2.52,
    width: 15.64,
    height: 10.97,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.98,
    cy: 7.99,
    r: 5.49,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(2.9 9.89)",
    fontSize: 5.95,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.04em",
    style: {
      isolation: "isolate"
    }
  }, "L"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(6.16 9.9)",
    fontSize: 5.95,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "-0.1em",
    style: {
      isolation: "isolate"
    }
  }, "A"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(9.04 9.89)",
    fontSize: 5.95,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fontFamily: "ArialMT, Arial",
    style: {
      isolation: "isolate"
    }
  }, "V")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavatory);
export default __webpack_public_path__ + "static/media/Lavatory.f96c2dddb0e336ce4d803a2f7f830930.svg";
export { ForwardRef as ReactComponent };